var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.code)?_c('div',[_c('span',{staticClass:"manufacturer"},[_vm._v("Kód produktu: "),_c('strong',{staticClass:"js-manufacturer"},[_vm._v(_vm._s(_vm.code))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }